import { PanelTrimType } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const convertToFlatTrimMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Convert to Flat Trim',
		isVisible: ({ controller, refMap }): boolean => {
			const { panelTrim } = refMap ?? {};
			if (controller?.readonly || !panelTrim) return false;

			return !panelTrim.isFlat;
		},
		onClick: ({ refMap }): void => {
			const { panelTrim } = refMap ?? {};
			if (!panelTrim) return;

			panelTrim.setTrimTypePaired(PanelTrimType.straight);
		}
	};
};
